import {
  ReactNode,
  ComponentPropsWithoutRef,
  forwardRef,
  ForwardedRef
} from 'react';
import { CheckMark, CheckContainer } from './style';

interface ICheckboxProps extends ComponentPropsWithoutRef<'input'> {
  children: ReactNode;
  checked?: boolean;
  className?: string;
  partialChecked?: boolean;
}

const Checkbox = (
  props: ICheckboxProps,
  ref: ForwardedRef<HTMLInputElement>
) => {
  const {
    children,
    name,
    checked,
    className,
    partialChecked,
    disabled,
    ...rest
  } = props;
  return (
    <div className={className}>
      <CheckContainer partialChecked={partialChecked} disabled={disabled}>
        {children}
        <input
          type="checkbox"
          name={name}
          checked={checked}
          disabled={disabled}
          {...rest}
          ref={ref}
        />
        <CheckMark disabled={disabled} />
      </CheckContainer>
    </div>
  );
};

export default forwardRef(Checkbox);
